module.exports = "<div class=gmw-verification-review__row> <div class=\"gmw-verification-review__col gmw-verification-review__col--label\" ng-bind=label> </div> <div class=\"gmw-verification-review__col h-dark-text\" ng-transclude> </div> <div class=\"gmw-verification-review__col gmw-verification-review__col--modify\" ng-if=modify> <a class=h-blue-link ng-bind=\"'Modify'|translate\" ui-sref=\"{{modify}}\"> </a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/review-row/review-row.html
// module id = 964
// module chunks = 0